<template>
	<div class="erji-content pp50">
		<div class="container">
			<div class="erji-title">
				<h1>{{title}}</h1>
				<h2>{{titleEn}}</h2>
			</div>
			<div class="erji-content-div">
				<div class="three_menu">
					<dl>
						<dd v-for="(item,index) in menuChilds" :key="index" :class="{ cur : index == curID }" @click="threeFun(item,index)">{{item.name}}</dd>
					</dl>
				</div>
				<div class="three_div-wp">
					<div class="three_div">
						<div class="single_detail" v-html="content"></div>
						<div class="branch_box">
							<h1 v-if="branch_box.title">{{branch_box.title}}</h1>
							<dl>
								<dd v-if="branch_box.division_head">处长：{{branch_box.division_head}}</dd>
								<dd v-if="branch_box.tel">电话：{{branch_box.tel}}</dd>
								<dd v-if="branch_box.email">邮箱：{{branch_box.email}}</dd>
							</dl>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		name:'branch',
		data(){
			return{
				title:'分支机构',
				titleEn:'BRANCHES',
				menuChilds:[],
				curID:0,
				threeBox:'',
				threeList:[],
				content:"",
				branch_box:{}
			}
		},
		methods:{
			res_menuChild(){
				this.axios.get('/api/menus/parentNumber?id='+this.$route.params.id)
					.then(response => {
						// 处理成功情况
						if(response.data.code == 200){
							this.menuChilds = response.data.reslut;
							this.res_single(this.menuChilds[0].id)
						}
					})
					.catch(error => {
						// 处理错误情况
						console.log(error);
					})
			},
			threeFun(item,index){
				this.content = "";
				this.branch_box = {}
				this.curID = index;
				this.res_single(item.id)
			},
			res_single(e){
				this.axios.get('/api/single?category_id='+e)
					.then(response => {
						// 处理成功情况
						if(response.data.code == 200){
							this.branch_box = response.data.reslut;
							this.content = this.branch_box.body.replace(
								/<img [^>]*src=['"]([^'"]+)[^>]*>/gi,
								(match, path) => {
									return path.search("http") == -1
										? `<img src='${this.icoURL}/${path}' />`
										: match;
								}
							);
						}
					})
					.catch(error => {
						// 处理错误情况
						console.log(error);
					})
			}
		},
		created() {
			this.res_menuChild();
		}
	}
</script>

<style>
</style>